<template>
  <div>
    <!-- 用例基础信息 -->
    <a-descriptions :column="3" size="small">
      <span slot="title">
        <span>{{ caseData.name }}</span>
      </span>
      <a-descriptions-item label="优先级">
        <a-tag v-if="![undefined, null].includes(caseData.priority)" :color="casePrioritys[caseData.priority].color"> {{ casePrioritys[caseData.priority].label }} </a-tag>
        <span v-else>--</span>
      </a-descriptions-item>
      <a-descriptions-item label="状态">
        <a-tag v-if="caseData.status" :color="caseStatus[caseData.status].color"> {{ caseStatus[caseData.status].label }} </a-tag>
        <span v-else>--</span>
      </a-descriptions-item>
      <a-descriptions-item label="创建人"><user-profiles v-if="caseData.creator" :value="[caseData.creator.id]" avatar /></a-descriptions-item>
      <a-descriptions-item label="最后修改人"><user-profiles v-if="caseData.modifier" :value="[caseData.modifier.id]" avatar /></a-descriptions-item>
      <a-descriptions-item label="创建时间">{{ caseData.created_time }} </a-descriptions-item>
      <a-descriptions-item label="更新时间"> {{ caseData.updated_time }} </a-descriptions-item>
      <a-descriptions-item label="优质用例">
        <case-premium-edit :value="caseData.premium" :case-id="caseId" @change="getCaseDetail" />
      </a-descriptions-item>
      <a-descriptions-item label="标签" :span="2">
        <a-tag v-for="(tag, index) in caseData.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
      </a-descriptions-item>
    </a-descriptions>
    <!-- 用例详细信息 -->
    <a-tabs size="small" @change="onChange">
      <a-tab-pane key="1" tab="详细信息">
        <a-descriptions layout="vertical" :column="2">
          <a-descriptions-item label="前置条件" :span="2">
            <span v-if="caseData.precondition" class="precondition">{{ caseData.precondition }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="操作步骤" :span="2">
            <a-table size="middle" class="steps_table" :pagination="false" :columns="columns" :data-source="caseData.steps" :row-key="(_, index) => index">
              <template slot="step" slot-scope="text, record">
                <span v-if="record.step" v-html="record.step.replace(/\n/g, '<br>')" />
              </template>
              <template slot="result" slot-scope="text, record">
                <span v-if="record.result" v-html="record.result.replace(/\n/g, '<br>')" />
              </template>
              <span slot="images" slot-scope="text, record">
                <CaseStepImages :data-list.sync="record.images" :is-edit="false" />
              </span>
            </a-table>
          </a-descriptions-item>
          <a-descriptions-item label="备注" :span="2">
            <vditor-preview :content="caseData.description === null ? '' : caseData.description" />
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
      <a-tab-pane key="2" tab="变更记录">
        <case-changelog :source-id="caseId" />
      </a-tab-pane>
      <a-tab-pane v-if="caseData.ai_score && caseData.ai_score.changeCase" key="3" tab="推荐用例">
        <CaseRecommend :change-case="caseData.ai_score.changeCase" />
      </a-tab-pane>
      <a-tab-pane v-if="false" key="3" tab="关联缺陷" disabled> 关联缺陷 </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { caseDetail } from '@/api/project/case';
import VditorPreview from '@/components/VditorEditor/preview';
import { casePrioritys, caseStatus } from '@/utils/dictionary';
import CaseChangelog from '@/pages/project/case/components/CaseChangelog';
import CaseStepImages from '@/pages/project/case/components/CaseStepImages';
import CasePremiumEdit from '@/pages/project/case/components/CasePremiumEdit';
import CaseRecommend from '@/pages/project/case/components/CaseRecommend';

const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: 60,
    customRender: (_text, _row, index) => {
      return index + 1;
    }
  },
  {
    with: 400,
    key: 'step',
    title: '操作步骤',
    dataIndex: 'step',
    scopedSlots: { customRender: 'step' }
  },
  {
    with: 400,
    key: 'result',
    title: '预期结果',
    dataIndex: 'result',
    scopedSlots: { customRender: 'result' }
  },
  {
    with: 200,
    title: '图片',
    key: 'images',
    dataIndex: 'images',
    scopedSlots: { customRender: 'images' }
  }
];
export default {
  components: { VditorPreview, CasePremiumEdit, CaseStepImages, CaseChangelog, CaseRecommend },
  props: {
    caseId: {
      type: [Number, String],
      default: null
    },
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      loading: true,
      visible: false,
      caseData: {},
      projectId: parseInt(this.$route.params.project_id) || null,
      tabItems: [
        { key: '1', label: '详细信息' },
        { key: '2', label: '变更记录' },
        { key: '3', label: '关联缺陷' }
      ]
    };
  },
  watch: {
    caseId: {
      handler: 'getCaseDetail',
      immediate: true
    }
  },
  methods: {
    onChange(activeKey) {
      const item = this.tabItems.find(item => item.key === activeKey);
      this.utils.trackClick({ name: '切换卡片', label: item ? item.label : activeKey });
    },
    // 获取用例详情
    getCaseDetail() {
      if (!this.caseId) {
        return;
      }
      if (Object.keys(this.dataSource).length === 0) {
        caseDetail({ project_id: this.projectId, id: this.caseId })
          .then(res => {
            this.caseData = res.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.caseData = this.dataSource;
        this.loading = false;
      }
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.description_fullscreen {
  float: right;
}

.precondition {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
